import React from 'react'
import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
// import messages from './messages'
import { Carousel } from 'antd-mobile'
import { MapCard2 } from 'components'
import _ from 'lodash'
import queryString from 'query-string'
import { isPayBy } from 'utils'

export default class MapCarousel extends React.Component {
  constructor(props) {
    super(props)
    const params = queryString.parseUrl(window.location.href)
    console.log(params)
    this.state = {
      showQRBtn: !!params.query.showQRBtn && isPayBy(),
    }
  }

  handleCarouselChange = (index) => {
    console.log('handleCarouselChange', index)
    const { form, storeList } = this.props
    const data = storeList[index]
    form.setFieldsValue({
      selectedMerchant: `${data.lat},${data.lng}`,
      selectedMerchantInfo: data,
    })
  }

  handleCarouselCurrent = () => {
    const { storeList, form } = this.props
    const selectedMerchant = form.getFieldValue('selectedMerchant')
    const index = _.findIndex(storeList, function(item) {
      const { lat, lng } = item
      return `${lat},${lng}` === selectedMerchant
    })
    if (index > -1) {
      return index
    }
    return 0
  }

  render() {
    const { storeList = [], categoryList = [], form } = this.props
    const tabs = []
    categoryList.map((item) => {
      tabs.push({ title: item.categoryDesc, key: item.category })
    })
    return (
      <div className={classes.componentsMapCarousel}>
        <Carousel
          className={classes.carousel}
          selectedIndex={this.handleCarouselCurrent()}
          frameOverflow='visible'
          cellSpacing={10}
          slideWidth={0.8}
          dots={false}
          afterChange={this.handleCarouselChange}
        >
          {storeList.map((item, index) => (
            <MapCard2
              fixedHeight
              key={`${item.merchantId}-${index}`}
              {...item}
              form={form}
            />
          ))}
        </Carousel>
      </div>
    )
  }
}
